module.exports = {
    createEmptyPromise: function () {
        return new Promise(function (resolve) {
            resolve();
        });
    },

    getFocusBack: function () {
        $('<input style="position: absolute;left: -999px;" type="text"/>')
            .appendTo('body')
            .css({'top': $(window).scrollTop()})
            .focus()
            .remove();
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/utils/Utils.js
// module id = 1
// module chunks = 0